import { render, staticRenderFns } from "./userinfoIndex.vue?vue&type=template&id=61cacaaf&scoped=true&"
import script from "./userinfoIndex.vue?vue&type=script&lang=js&"
export * from "./userinfoIndex.vue?vue&type=script&lang=js&"
import style0 from "./userinfoIndex.vue?vue&type=style&index=0&id=61cacaaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cacaaf",
  null
  
)

export default component.exports